module.exports = __webpack_public_path__ + "img/print-logo.d589ee6c.png";